export default __webpack_public_path__ + "static/media/iconDiscover.17eb1f0c.png";